import React, { Component } from 'react';
import axios from 'axios';
import Checkbox from '@material-ui/core/Checkbox';
import { convertFromHTML, EditorState, ContentState } from 'draft-js';

import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { DropDownList, DropDownListChild } from '../../Elements/Select/dropdown';
import ButtonLoader from '../../Elements/Button/button';
import ResourcePagination from '../../Elements/Pagination/resourcepagination';
import EventPagination from '../../Elements/Pagination/eventpagination';

import cookie from 'react-cookies';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import {toBase64, updateValueInJson, ValidateArrayState} from '../../../functions';
import {
    API_URL,
    BASE_URL_CMS,
    BASE_URL_RECURSOS,
    BASE_URL_FRONTEND
} from '../../../constants';
import {ValidateState} from '../../../functions';
import Error from '../../Error/error';
import TextareaWithCounter from '../../Elements/TextareaWithCounter';

import ImageUploader from 'react-images-upload';

//tabs
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import BulletinIcon from '@material-ui/icons/EventNote';
import ImagenIcon from '@material-ui/icons/Image';
import DocumentIcon from '@material-ui/icons/AttachFile';

import InComponentLoader from '../../Elements/Loader/componentloader';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';

import '../../../assets/css/siicex-usuario.css';
import { PaginationImages } from '../../Elements/Pagination/ImgPagination';
import ImgUploader from '../../Elements/imgUploader';
import InputWithCounter from '../../Elements/InputWithCounter';

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
        >
            <Box>
                {children}
            </Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class EditEventos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReprogramado: false,
            event:      null,
            response:   [],
            error:      [],
            sectors:    [],
            roles:      [],
            estadoa:    [],
            loading:    false,
            loadData:   true,

            editorState:        EditorState.createEmpty(),
            editorStateHTML :   '' ,
            editorStateB:       EditorState.createEmpty(),
            editorStateHTMLB :  '',

            security:           cookie.load('user'),

            numeroTab:          0,
            HTML:               '<span>&nbsp</span>',

            imagesToSelect:     false,
            selectedImage:      false,
            selectedFile:       false,
            currentImagePage:   1,

            selectsLoadedCount:         0,
            selectsLoaded:              false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        this.getImages  = this.getImages.bind(this);
        this.changeImg = this.changeImg.bind(this);
    }

    // handleInputChangeDate(name, control){
    //     let copy = JSON.parse(JSON.stringify(this.state.event));
    //     copy[name] = Moment(control).format();

    //      this.setState({
    //         event: copy
    //     });
    // }

    handleInputChangeDate = (name, val) => {
        let { event } = this.state;
        event[name] = val ? val : null; 
        this.setState({ event });
    };

    handleInputChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copy = JSON.parse(JSON.stringify(this.state.event));
        copy[target.name] = value;
        if(event.target.id==="sTitulo"){
            let _value = event.target.value.toLocaleLowerCase();
            [   {val: " ", replace: "-"},
                {val: "á", replace: "a"},
                {val: "é", replace: "e"},
                {val: "í", replace: "i"},
                {val: "ó", replace: "o"},
                {val: "ú", replace: "u"},
            ].forEach((letter) => {
                while(_value.indexOf(letter.val)!=-1) _value = _value.replace(letter.val, letter.replace);
            });

            copy['sUrlCanonical'] = _value;
        }
        this.setState({ event: copy });
    }

    handleClickCancel(e){
        // const {history: {push}} = this.props;
        // window.location.href = BASE_URL_CMS + "/eventos";

        this.props.history.push({
            pathname: '/eventos',
        });
    }

    callFunctionButton = (event) => {
        let vStep = "ini" ;    
        let _isOk = true;

        const {history: {push}}         = this.props;
        const url                       = `${API_URL}EventUX`;
        var dataForm                    = this.state.event;
        var even_Estado                 = dataForm.even_Estado;
        var Even_EstadoActividad        = dataForm.Even_EstadoActividad || dataForm.even_EstadoActividad || { value: 'O' };
        var Even_CoOrganizador          = dataForm.Even_CoOrganizador;
        var even_Activo                 = dataForm.even_Activo;
        var even_Tipo                   = dataForm.even_Tipo;
        var even_TipoAsistencia         = dataForm.even_TipoAsistencia;
        var lEventoPartida              = dataForm.lEventoPartida;
        var partida                     = lEventoPartida ? lEventoPartida.filter((v) => v.hasOwnProperty("value")).map((v) => v.value) : lEventoPartida;
        dataForm                        = updateValueInJson(dataForm,'lEventoPartida', String((partida === null ? "" : partida)));

        dataForm = updateValueInJson(dataForm,'even_Estado', even_Estado.value);
        dataForm = updateValueInJson(dataForm,'Even_EstadoActividad', Even_EstadoActividad.value);

        let coorgVal = dataForm.Even_CoOrganizador || dataForm.even_CoOrganizador;
        coorgVal = coorgVal && coorgVal.value !== undefined ? coorgVal.value : coorgVal;
        coorgVal = (coorgVal == 0 || coorgVal === "0") ? "" : coorgVal;

        dataForm = updateValueInJson(dataForm,'even_Activo', even_Activo.value);
        dataForm = updateValueInJson(dataForm,'even_Tipo',   even_Tipo.value);
        dataForm = updateValueInJson(dataForm,'even_TipoAsistencia',   even_TipoAsistencia.value);
        dataForm = updateValueInJson(dataForm,'even_ImagenPortada', (dataForm.sImagen && dataForm.sImagenMovil !== "")  ? dataForm.sImagen: "");
        dataForm = updateValueInJson(dataForm,'even_ImagenPortadaMovil', (dataForm.sImagenMovil && dataForm.sImagenMovil !== "")  ? dataForm.sImagenMovil : "");

        if( this.state.event.even_Estado && this.state.event.even_Estado.hasOwnProperty("value") && this.state.event.even_Estado.value === "P")
            {
            if(ValidateState(this.state.event, 'even_Titulo', '')){toast.error('Error en Validación: Ingrese un Título.'); _isOk = false;}
            if(dataForm.even_Tipo.toString() === "0"){dataForm = updateValueInJson(dataForm,'even_Tipo', "");}
            if(dataForm.even_TipoAsistencia.toString() === "0"){dataForm = updateValueInJson(dataForm,'even_TipoAsistencia', "");}
            if(ValidateState(dataForm, 'Even_EstadoActividad', '')){toast.error('Seleccione un estado de actividad.'); _isOk = false;}
        }else{

            if(ValidateState(dataForm, 'even_Titulo', '')){toast.error('Error en Validación: Ingrese un Título.'); _isOk = false;}
            if(ValidateState(this.state.event, 'even_Extracto', '')){toast.error('Error en Validación: Ingrese un Extracto.'); _isOk = false;}
            if(ValidateState(dataForm, 'even_ImagenPortada', '')){toast.error('Error en Validación: Ingrese una imagen de portada.'); _isOk = false;}
            // if(ValidateState(dataForm, 'even_ImagenPortadaMovil', '')){toast.error('Error en Validación: Ingrese una imagen de portada (movil).'); _isOk = false;}

            if(ValidateState(this.state.event, 'even_Enlace', '')){toast.error('Error en Validación: Ingrese un enlace.'); _isOk = false;}
            if(ValidateState(this.state.event, 'even_Direccion', '')){toast.error('Error en Validación: Ingrese una dirección.'); _isOk = false;}
            if(ValidateState(this.state.event, 'even_LugarEvento', '')){toast.error('Error en Validación: Ingrese un lugar de evento.'); _isOk = false;}
            
            if(ValidateState(this.state.event, 'even_Estado', '')){toast.error('Error en Validación: Seleccione un estado.'); _isOk = false;}
            if(ValidateState(this.state.event, 'Even_EstadoActividad', '')){toast.error('Error en Validación: Seleccione un estado de actividad.'); _isOk = false;}
            if(ValidateState(this.state.event, 'even_Activo', '')){toast.error('Error en Validación: Activo.'); _isOk = false;}
            if(ValidateArrayState(dataForm, 'even_Tipo', '')){toast.error('Error en Validación: Ingrese un tipo.'); _isOk = false;}
            if(ValidateArrayState(dataForm, 'even_TipoAsistencia', '')){toast.error('Error en Validación: seleccione un tipo de asistencia.'); _isOk = false;}

            if(ValidateArrayState(dataForm, 'lEventoFichaProducto', '')){  toast.error('Error en Validación: Seleccione una ficha de producto.'); _isOk = false; }
            if(ValidateState(this.state.event, 'lEventoPais', '')){  toast.error('Error en Validación: Seleccione al menos una Ubicación.'); _isOk = false; }
            // if(ValidateArrayState(dataForm, 'lEventoPartida', '')){  toast.error('Error en Validación: Seleccione al menos una Partida.'); _isOk = false; }
            if(ValidateArrayState(this.state.event, 'lEventoSector', '')){  toast.error('Error en Validación: Seleccione al menos un Sector.'); _isOk = false; }
            // if(ValidateArrayState(this.state.event, 'lEventoLineaProducto', '')){  toast.error('Error en Validación: Seleccione linea de producto.'); _isOk = false; }
        }

        let fInicio = this.state.event.even_FechaInicio;
        let fFin = this.state.event.even_FechaFin;
        vStep= "even_FechaInicio";
        
        if (fInicio || fFin) {
            if (!fInicio || !fFin) {
                toast.error('Debe ingresar la fecha de inicio y término del evento');
                _isOk = false;
            } else if (Moment(fFin).isBefore(Moment(fInicio), 'day')) {
                toast.error('La fecha fin del evento no puede ser menor a la fecha de inicio');
                _isOk = false;
            }
        }

        let fInsIni = dataForm.Even_FechaIncripcionIni || dataForm.even_FechaIncripcionIni;
        let fInsFin = dataForm.Even_FechaIncripcionFin || dataForm.even_FechaIncripcionFin;
        vStep= "even_FechaIncripcionIni";

        if (fInsIni || fInsFin) {
            if (!fInsIni || !fInsFin) {
                toast.error('Debe ingresar ambas fechas de inscripción');
                _isOk = false;
            } else if (Moment(fInsFin).isBefore(Moment(fInsIni), 'day')) {
                toast.error('La fecha fin de inscripción no puede ser menor a la fecha de inicio');
                _isOk = false;
            }
        }

        let fReproIni = dataForm.Even_FechaReproIni || dataForm.even_FechaReproIni;
        let fReproFin = dataForm.Even_FechaReproFin || dataForm.even_FechaReproFin;
        vStep= "even_FechaReproIni";
        
        if (this.state.isReprogramado || fReproIni || fReproFin) {
            if (!fReproIni || !fReproFin) {
                toast.error('Debe ingresar ambas fechas de reprogramación');
                _isOk = false;
            } else if (Moment(fReproFin).isBefore(Moment(fReproIni), 'day')) {
                toast.error('La fecha de fin de reprogramación no puede ser menor a la de inicio');
                _isOk = false;
            }
        }
        
        if(_isOk){
            console.log("FORM_VALID" )
        }
        else
            {
            event.preventDefault();
            console.log("FORM_NO_VALID step", vStep )
            return;
        }

        dataForm = updateValueInJson(dataForm,'even_UsuarioEdicion', this.state.security.nUsuCodigo);
        dataForm = updateValueInJson(dataForm,'even_FechaFin', Moment(this.state.event.even_FechaFin).format("YYYY-MM-DD"));
        dataForm = updateValueInJson(dataForm,'even_FechaInicio', Moment(this.state.event.even_FechaInicio).format("YYYY-MM-DD"));
        dataForm = updateValueInJson(dataForm,'even_FechaPublicacion', Moment(this.state.event.even_FechaPublicacion).format("YYYY-MM-DD"));

        var lEventoSector               = dataForm.lEventoSector;
        var lEventoLineaProducto        = dataForm.lEventoLineaProducto;
        var lEventoPais                 = dataForm.lEventoPais;
        var lEventoFichaProducto        = dataForm.lEventoFichaProducto;
        
        // var dlEventoSector              = lEventoSector.map(v => v.value.split("-")[0]);
        // var dlEventoLineaProducto       = lEventoLineaProducto.map(v => v.value);
        // var dlEventoPais                = lEventoPais.map(v => v.value);
        // var dlEventoFichaProducto       = lEventoFichaProducto.map(v => v.value);
        
        var dlEventoSector              = (lEventoSector || []).map(v => v.value ? v.value.split("-")[0] : v);
        var dlEventoLineaProducto       = (lEventoLineaProducto || []).map(v => v.value || v);
        var dlEventoPais                = (lEventoPais || []).map(v => v.value || v);
        var dlEventoFichaProducto       = (lEventoFichaProducto || []).map(v => v.value || v);
        
        // var dlEventoPartida          = lEventoPartida.map(v => v.value);
        //dataForm = updateValueInJson(dataForm,'lEventoSector', String(dlEventoSector));

        dataForm = updateValueInJson(dataForm,'lEventoSector', String(dlEventoSector));
        dataForm = updateValueInJson(dataForm,'lEventoLineaProducto', String(dlEventoLineaProducto));
        dataForm = updateValueInJson(dataForm,'lEventoPais', String(dlEventoPais));
        dataForm = updateValueInJson(dataForm,'lEventoFichaProducto', String(dlEventoFichaProducto));

        let formatData = {
            Even_Id:                    dataForm.even_Id,
            Even_Titulo:                dataForm.even_Titulo,
            Even_Extracto:              dataForm.even_Extracto,
            Even_ImagenPortada:         dataForm.even_ImagenPortada,
            Even_ImagenPortadaMovil:    dataForm.even_ImagenPortadaMovil,
            Even_Estado:                dataForm.even_Estado,
            Even_EstadoActividad :      dataForm.Even_EstadoActividad,
            Even_CoOrganizador :        coorgVal,
            Even_Activo:                dataForm.even_Activo,
            Even_Tipo:                  dataForm.even_Tipo,
            Even_TipoAsistencia:        dataForm.even_TipoAsistencia,

            Even_Enlace:                dataForm.even_Enlace,
            Even_Direccion:             dataForm.even_Direccion,
            Even_LugarEvento:           dataForm.even_LugarEvento,
            Even_UsuarioEdicion:        dataForm.even_UsuarioEdicion,

            Even_FechaPublicacion:      dataForm.even_FechaPublicacion,
            Even_FechaInicio:           dataForm.even_FechaInicio,
            Even_FechaFin:              dataForm.even_FechaFin,

            listEventoFichaProducto:    dataForm.lEventoFichaProducto,
            listEventoLineaProducto:    dataForm.lEventoLineaProducto,
            listEventoPais:             dataForm.lEventoPais,
            listEventoPartida:          dataForm.lEventoPartida,
            listEventoSector:           dataForm.lEventoSector,

            Even_FechaReproIni: (this.state.isReprogramado && (dataForm.Even_FechaReproIni || dataForm.even_FechaReproIni)) ? Moment(dataForm.Even_FechaReproIni || dataForm.even_FechaReproIni).format("YYYY-MM-DD") : null,
            Even_FechaReproFin: (this.state.isReprogramado && (dataForm.Even_FechaReproFin || dataForm.even_FechaReproFin)) ? Moment(dataForm.Even_FechaReproFin || dataForm.even_FechaReproFin).format("YYYY-MM-DD") : null,
            Even_FechaIncripcionIni: (dataForm.Even_FechaIncripcionIni || dataForm.even_FechaIncripcionIni) ? Moment(dataForm.Even_FechaIncripcionIni || dataForm.even_FechaIncripcionIni).format("YYYY-MM-DD") : null,
            Even_FechaIncripcionFin: (dataForm.Even_FechaIncripcionFin || dataForm.even_FechaIncripcionFin) ? Moment(dataForm.Even_FechaIncripcionFin || dataForm.even_FechaIncripcionFin).format("YYYY-MM-DD") : null,
            Even_CancelarMotivo: dataForm.Even_CancelarMotivo || dataForm.even_CancelarMotivo || "",
            Even_CancelarMotivo: dataForm.Even_CancelarMotivo || dataForm.even_CancelarMotivo || "",
        }
        
        const formData = JSON.stringify(formatData);
        console.log("FORMULARIO: " , formatData);
        
        axios.put(
            url,
            JSON.stringify(formData),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }
        ).then( data => {
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");

            if (data.data.isSucess){
                toast.success('Evento actualizado correctamente. \n Se redireccionará al listado');
                setTimeout(() => { 
                    // window.location.href = BASE_URL_CMS + "/eventos"
                    this.props.history.push({
                        pathname: '/eventos',
                    });

                }, 1000);
            }else{
                this.setState({loading:false});
                toast.error('No se pudo actualizar el Evento. \r');
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({ loading:false });
        });
        
    }

    handleClickSubmit(e){
        e.preventDefault();
    }

    componentDidMount(){
        localStorage.setItem("load", false);

        let search = window.location.search;
        let params = new URLSearchParams(search);
        const { id } = this.props.match.params;
        // var key = params.get('id'); 
        // var key = this.props.location.state.key;

        const url = `${API_URL}EventUX/${id}`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            console.log("EDIT", data);

            let tmp = {...data.result};
                if(tmp.even_ImagenPortada && tmp.even_ImagenPortada !== ""){
                    // tmp['sImagen'] = tmp.even_ImagenPortada.replace(BASE_URL_RECURSOS, "");
                    tmp['sImagen'] = tmp.even_ImagenPortada;
                }

                if(tmp.even_ImagenPortadaMovil && tmp.even_ImagenPortadaMovil !== ""){
                    // tmp['sImagenMovil'] = tmp.even_ImagenPortadaMovil.replace(BASE_URL_RECURSOS, "");
                    tmp['sImagenMovil'] = tmp.even_ImagenPortadaMovil;
                }

            if(!tmp.even_TipoAsistencia){
                tmp['even_TipoAsistencia'] = "";
            }

            this.getImages();

            let isRepro = (tmp.even_FechaReproIni != null || tmp.Even_FechaReproIni != null);
            this.setState({ 
                event: tmp, 
                isReprogramado: isRepro,
            }, () => {
                // // console.log(this.state.event);
                this.setState({ 
                    response:   data, 
                    error:      data.Error, 
                    loadData:   false
                });
            });
        })
        .catch(error => {
            // console.log(error);
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            toast.error("¡Error al inicializar!");
        });
    }

    handleToggleReprogramado = (event) => {
        this.setState({ isReprogramado: event.target.checked }, () => {
            if (!this.state.isReprogramado) {
                let copy = JSON.parse(JSON.stringify(this.state.event));
                copy.even_FechaReproIni = null;
                copy.Even_FechaReproIni = null;
                copy.even_FechaReproFin = null;
                copy.Even_FechaReproFin = null;
                this.setState({ event: copy });
            }
        });
    }

    isRequiredSpan = () => {
        if(
            this.state.event.even_Estado && 
            this.state.event.even_Estado.hasOwnProperty("value") && 
            this.state.event.even_Estado.value === "A"
        ){
            return <span className='font-weight-bold text-danger ml-2'>*</span>
        }else{
            return ""
        }   
    }

    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };

    getImages( page = 1 ){
        const urlBase  = `${API_URL}`
        axios.get(urlBase + `FileUX/0/${page}/all/all/all`).then(response => response.data)
        .then((data) => {

            this.setState({ 
                imagesToSelect: data.result, 
                currentImagePage: page
            });

        }).catch(error => {
          console.error(error);
        });
    }

    onLoad = () => {
        // console.log(this.state.selectsLoadedCount);

        this.setState({
            selectsLoadedCount: this.state.selectsLoadedCount + 1
        }, () => {
            // // console.log(this.state.selectsLoadedCount);
            if(this.state.selectsLoadedCount >= 1){
                this.setState({
                    selectsLoaded: true
                });
            }
        });
    }

    changeImg = (flag, routeImg, cod) => {
        let _tmp = {};

        _tmp = updateValueInJson(this.state.event, flag, routeImg);
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', cod);

        this.setState({ 
            event: _tmp 
        }, () => {
            // console.log(this.state.event);
        });
    }

    render(){
        if (!this.state.event || this.state.loadData) {return <div className="loader"></div>; 
    }
        Moment.updateLocale('en', {
            months : ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"]
        });
        Moment.updateLocale('en', { weekdays : ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"] });

        let typeselect = "portada";

        if(this.state.numeroTab === 1){
            typeselect = "portada";
        }else if(this.state.numeroTab === 2){
            typeselect = "portadamovil";
        }
        // // console.log(this.state.event);

        return(
            (this.state.response.statusCode === 200 && !this.state.loadData) ?
                
                <div id="detailBody" className="Site-content">
                    <div hidden className="loader"></div>

                    <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} autoComplete="off" >
                        <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">

                                    <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                                <a href="/">
                                                    / Panel de configuración general
                                                </a>
                                                <Link to="/administradores">
                                                    / Administradores
                                                </Link>
                                                <Link to="/eventos">
                                                    / Eventos
                                                </Link>
                                            <span> / Editar evento</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                        Editar evento
                                    </div>

                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-10">
                                                       
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="boletin__filters section__margin-bottom">
                                                                    
                                                                    <div className="form-group">
                                                                        <label className='h6' htmlFor="even_Titulo">
                                                                            <strong>Título</strong>
                                                                            <span className='font-weight-bold text-danger ml-2'>*</span>
                                                                        </label>
                                                                        <InputWithCounter
                                                                            name="even_Titulo" 
                                                                            id="even_Titulo" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_Titulo} 
                                                                            count={this.state.event.even_Titulo}
                                                                            maxlength={200}
                                                                            placeholder="Título"
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label className='h6' htmlFor="even_Extracto">
                                                                            <strong>Extracto</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>

                                                                        <TextareaWithCounter
                                                                            name="even_Extracto" 
                                                                            id="even_Extracto" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_Extracto} 
                                                                            count={this.state.event.even_Extracto}
                                                                            maxlength={500}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label htmlFor="even_Tipo" className='h6'>
                                                                            <strong>Tipo de evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList 
                                                                                valor={this.state.event.even_Tipo === "" ? 0 : this.state.event.even_Tipo} 
                                                                                isMulti={false} 
                                                                                name="even_Tipo" 
                                                                                id="even_Tipo"  
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.even_Tipo} 
                                                                                componente={"Even_Tipo"} 
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label className='h6' htmlFor="Even_Extracto">
                                                                            <strong>Banner del evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>

                                                                        <ImgUploader 
                                                                            // modalImg={() => this.setState({ flagimg: "sImagen" })}
                                                                            value={this.state.event.sImagen}
                                                                            name="even_ImagenPortada" 
                                                                            id="even_ImagenPortada" 
                                                                            onChange={(rutaimg, cod) => this.changeImg('sImagen', rutaimg, cod)}
                                                                        />

                                                                        <p style={{fontSize: 15, marginTop: 4}}>
                                                                            Se recomienda la 
                                                                            dimensión de 263px de ancho X 213px de alto.
                                                                        </p>

                                                                    </div>

                                                                    {/*
                                                                    <div className="form-group">
                                                                        <label className='h6' htmlFor="Even_Extracto">
                                                                            <strong>Imagen de portada (movil)</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>

                                                                        <ImgUploader 
                                                                            // modalImg={() => this.setState({ flagimg: "sImagenMovil" })}
                                                                            value={this.state.event.sImagenMovil}
                                                                            name="even_ImagenPortadaMovil" 
                                                                            id="even_ImagenPortadaMovil" 
                                                                            onChange={(rutaimg, cod) => this.changeImg('sImagenMovil', rutaimg, cod)}
                                                                        />

                                                                        <p style={{fontSize: 15, marginTop: 4}}>
                                                                            Se recomienda la 
                                                                            dimensión de 263px de ancho X 213px de alto.
                                                                        </p>
                                                                    </div>
                                                                     */}

                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="boletin__filters section__margin-bottom">
                                                                    <div className="form-group">
                                                                        <label htmlFor="lEventoPais" className='h6'>
                                                                            <strong>Mercado</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList 
                                                                                valor={this.state.event.lEventoPais} 
                                                                                isMulti={true} 
                                                                                name="lEventoPais" 
                                                                                id="lEventoPais"  
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.lEventoPais} 
                                                                                componente={"Ubicacion"} 
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label htmlFor="listEventoPais" className='h6'>
                                                                            <strong>Asistencia</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList 
                                                                                valor={this.state.event.even_TipoAsistencia !== "" ? this.state.event.even_TipoAsistencia : "0"} 
                                                                                isMulti={false} 
                                                                                name="even_TipoAsistencia" 
                                                                                id="even_TipoAsistencia"  
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.even_TipoAsistencia} 
                                                                                componente={"Tipo_asistencia"} 
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label htmlFor="lEventoSector" className='h6'>
                                                                            <strong>Sector</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList
                                                                                clave={this.state.event.lEventoSector}
                                                                                valor={this.state.event.lEventoSector}

                                                                                child="LineaProducto" 
                                                                                valorHijo={this.state.event.lEventoLineaProducto}

                                                                                name="lEventoSector"
                                                                                id="lEventoSector" 
                                                                                onChange={this.handleInputChange}
                                                                                
                                                                                componente={"EventSector"}
                                                                                isMulti={true} />
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className="form-group">
                                                                        <label htmlFor="lEventoFichaProducto" className='h6'>
                                                                            <strong>Producto</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList 
                                                                                valor={this.state.event.lEventoFichaProducto} 
                                                                                isMulti={true} 
                                                                                name="lEventoFichaProducto" 
                                                                                id="lEventoFichaProducto"  
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.lEventoFichaProducto} 
                                                                                componente={"fichaProducto"} 
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className="form-group">
                                                                        <label htmlFor="lEventoPartida" className='h6'>
                                                                            <strong>Partida</strong>
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList 
                                                                                name="lEventoPartida" 
                                                                                id="lEventoPartida"
                                                                                onChange={this.handleInputChange}
                                                                                onLoad={() => this.onLoad()}
                                                                                valor={this.state.event.lEventoPartida}
                                                                                componente={"Partida"}
                                                                                isMulti={true} 
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="lEventoLineaProducto" className='h6'>
                                                                            <strong>Línea de Producto</strong>
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownListChild  
                                                                                metodo={"add"} 
                                                                                // valor={0}
                                                                                // etiqueta={"Seleccione una Opción de la Lista"}
                                                                                clavePadre={this.state.event.nSectorCodigo}
                                                                                name="lEventoLineaProducto"
                                                                                parent="Sector" 
                                                                                id="lEventoLineaProducto"
                                                                                onChange={this.handleInputChange}
                                                                                clave={this.state.event.lEventoLineaProducto}
                                                                                componente={"LineaProducto"} 
                                                                                isMultiple={true} 
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="even_Estado" className='h6'>
                                                                            <strong>Estado</strong>
                                                                            <span className='font-weight-bold text-danger ml-2'>*</span>
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList  
                                                                                filtro={this.state.roles}  
                                                                                valor={this.state.event.even_Estado} 
                                                                                // etiqueta={"PUBLICADO"}  
                                                                                metodo="added"  
                                                                                name="even_Estado" 
                                                                                id="even_Estado" 
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.even_Estado} 
                                                                                componente={"Even_Estado"} 
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="Even_EstadoActividad" className='h6'>
                                                                            <strong>Estado de actividad</strong>
                                                                            <span className='font-weight-bold text-danger ml-2'>*</span>
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList  
                                                                                filtro={[]}
                                                                                valor={this.state.event.even_EstadoActividad} 
                                                                                metodo="added"  
                                                                                name="Even_EstadoActividad" 
                                                                                id="Even_EstadoActividad" 
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.even_EstadoActividad} 
                                                                                componente={"Even_EstadoActividad"} 
                                                                            />
                                                                        </div>
                                                                    </div>                                                                    

                                                                    <div className="form-group">
                                                                        <label htmlFor="Even_CoOrganizador" className='h6'>
                                                                            <strong>Co Organizador</strong>
                                                                            {/* <span className='font-weight-bold text-danger ml-2'>*</span> */}
                                                                        </label>
                                                                        <div className="">
                                                                            {/* <input 
                                                                                type="text" 
                                                                                name="Even_CoOrganizador" 
                                                                                id="Even_CoOrganizador" 
                                                                                onChange={this.handleInputChange} 
                                                                                defaultValue={this.state.event.even_CoOrganizador} 
                                                                                className="form-control text-filter__form-control" 
                                                                                maxlength={200}
                                                                                placeholder="Coorganizador" 
                                                                             />                                                                             */}
                                                                            <DropDownList 
                                                                                metodo="edit"  
                                                                                valor={(this.state.event.even_CoOrganizador || this.state.event.Even_CoOrganizador || "") === "" ? 0 : (this.state.event.even_CoOrganizador || this.state.event.Even_CoOrganizador)}
                                                                                isMulti={false} 
                                                                                name="even_CoOrganizador" 
                                                                                id="even_CoOrganizador"  
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.even_CoOrganizador || this.state.event.Even_CoOrganizador} 
                                                                                componente={"RECURSO_COORGANIZADOR"}
                                                                            />                                                                          
                                                                        </div>
                                                                    </div>                                                                    

                                                                    <div className="form-group">
                                                                        <label htmlFor="even_Activo" className='h6'>
                                                                            <strong>Activo</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <div className="">
                                                                            <DropDownList 
                                                                                valor={this.state.event.even_Activo} 
                                                                                etiqueta={"ACTIVO"} 
                                                                                metodo="added"  
                                                                                name="even_Activo" 
                                                                                id="even_Activo" 
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.even_Activo} 
                                                                                componente={"Even_Activo"} 
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label htmlFor="even_CancelarMotivo" className='h6'><strong>Motivo de cancelación o reprogramación</strong></label>
                                                                        <TextareaWithCounter
                                                                            name="even_CancelarMotivo" 
                                                                            id="even_CancelarMotivo" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_CancelarMotivo || this.state.event.Even_CancelarMotivo || ""} 
                                                                            count={this.state.event.even_CancelarMotivo || this.state.event.Even_CancelarMotivo || ""}
                                                                            maxlength={90}  
                                                                            placeholder="Ingrese el motivo de motivo de cancelación o reprogramación"
                                                                        />                                                                     
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="boletin__filters section__margin-bottom">
                                                                    <div className="form-group">
                                                                        <label className='h6'>
                                                                            <strong>Fecha de Publicación</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <DatePicker autoComplete="off"
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("even_FechaPublicacion", val)}
                                                                            value={Moment(this.state.event.even_FechaPublicacion).format('dddd DD, MMMM YYYY')}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label className='h6'>
                                                                            <strong>Fecha Inicio del Evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <DatePicker autoComplete="off"
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("even_FechaInicio", val)}
                                                                            value={Moment(this.state.event.even_FechaInicio).format('dddd DD, MMMM YYYY')}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label className='h6'>
                                                                            <strong>Fecha Fin del Evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <DatePicker autoComplete="off"
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("even_FechaFin", val)}
                                                                            value={Moment(this.state.event.even_FechaFin).format('dddd DD, MMMM YYYY')}
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <hr></hr>
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label className='h6'><strong>Inicio de inscripción</strong></label>
                                                                        <DatePicker autoComplete="off"
                                                                            isClearable
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("even_FechaIncripcionIni", val)}
                                                                            selected={(this.state.event.even_FechaIncripcionIni || this.state.event.Even_FechaIncripcionIni) 
                                                                                ? new Date(this.state.event.even_FechaIncripcionIni || this.state.event.Even_FechaIncripcionIni) : null}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            placeholderText="Seleccione fecha inicio"
                                                                        />
                                                                    </div>

                                                                    <div className="form-group">
                                                                        <label className='h6'><strong>Fin de inscripción</strong></label>
                                                                       <DatePicker autoComplete="off"
                                                                            isClearable
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("even_FechaIncripcionFin", val)}
                                                                            selected={(this.state.event.even_FechaIncripcionFin || this.state.event.Even_FechaIncripcionFin) 
                                                                                ? new Date(this.state.event.even_FechaIncripcionFin || this.state.event.Even_FechaIncripcionFin) : null}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            placeholderText="Seleccione fecha fin"
                                                                        />
                                                                    </div>

                                                                    <hr />

                                                                    <div className="form-group border p-2 bg-light d-flex align-items-center" style={{ borderRadius: '4px' }}>
                                                                        <Checkbox
                                                                            id="chkRepro"
                                                                            checked={this.state.isReprogramado}
                                                                            onChange={this.handleToggleReprogramado}
                                                                            color="primary"
                                                                            style={{ padding: '5px' }}
                                                                        />
                                                                        <label className="h6 mb-0 ml-2" htmlFor="chkRepro" style={{ cursor: 'pointer', marginTop: '4px' }}>
                                                                            <strong>¿Evento Reprogramado?</strong>
                                                                        </label>
                                                                    </div>

                                                                    {this.state.isReprogramado && (
                                                                        <div className="p-3 mb-3 border rounded shadow-sm" style={{backgroundColor: '#fff'}}>
                                                                            <div className="form-group">
                                                                                <label className='h6'><strong>Nueva fecha inicio</strong> *</label>
                                                                                <DatePicker autoComplete="off"
                                                                                    isClearable
                                                                                    className="form-control text-filter__form-control_date col-12"
                                                                                    onChange={(val) => this.handleInputChangeDate("even_FechaReproIni", val)}
                                                                                    selected={(this.state.event.even_FechaReproIni || this.state.event.Even_FechaReproIni) 
                                                                                        ? new Date(this.state.event.even_FechaReproIni || this.state.event.Even_FechaReproIni) : null}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    placeholderText="Inicio reprogramado"
                                                                                />
                                                                            </div>
                                                                            <div className="form-group mb-0">
                                                                                <label className='h6'><strong>Nueva fecha fin</strong> *</label>
                                                                                <DatePicker autoComplete="off"
                                                                                    isClearable
                                                                                    className="form-control text-filter__form-control_date col-12"
                                                                                    onChange={(val) => this.handleInputChangeDate("even_FechaReproFin", val)}
                                                                                    selected={(this.state.event.even_FechaReproFin || this.state.event.Even_FechaReproFin) 
                                                                                        ? new Date(this.state.event.even_FechaReproFin || this.state.event.Even_FechaReproFin) : null}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    placeholderText="Fin reprogramado"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div className="form-group">
                                                                        <label htmlFor="even_Enlace" className='h6'>
                                                                            <strong>Enlace del evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="even_Enlace" 
                                                                            id="even_Enlace" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_Enlace} 
                                                                            className="form-control text-filter__form-control" 
                                                                            placeholder="Enlace de interés" 
                                                                        />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="even_Direccion" className='h6'>
                                                                            <strong>Dirección</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="even_Direccion" 
                                                                            id="even_Direccion" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_Direccion} 
                                                                            className="form-control text-filter__form-control" 
                                                                            maxlength={200}
                                                                            placeholder="Dirección del evento" 
                                                                        />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="even_LugarEvento" className='h6'>
                                                                            <strong>Lugar del evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="even_LugarEvento" 
                                                                            id="even_LugarEvento" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_LugarEvento} 
                                                                            className="form-control text-filter__form-control" 
                                                                            maxlength={200}
                                                                            placeholder="Lugar del evento" 
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-start">
                                                            <div className="d-flex justify-content-start">
                                                                <button 
                                                                    type="button" 
                                                                    onClick={(event) => this.handleClickCancel(event)} 
                                                                    className="btn btn-default btn-primary__submit"
                                                                >
                                                                    Cancelar
                                                                </button>
                                                                &nbsp;
                                                                <ButtonLoader 
                                                                    bloqueado={!this.state.selectsLoaded}
                                                                    text="GUARDAR" 
                                                                    textProcessing="PROCESANDO..." 
                                                                    loading={this.state.loading} 
                                                                    callFunctionButton={(e) => this.callFunctionButton(e)}
                                                                ></ButtonLoader>
                                                            </div>
                                                        </div>      
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            :
                <Error StatusCode="500" StatusMessage="Error"></Error>
            
        )
    }
}

export default EditEventos;